<div
	class="h-full w-full cursor-pointer rounded-md 
		border-2 border-thatBlue-500 bg-white text-base 
		font-medium text-thatBlue-500 shadow 
		transition duration-150 ease-in-out
		hover:bg-thatBlue-500 hover:text-white 
		focus:border-thatBlue-800 focus:bg-thatBlue-500 
		focus:text-white focus:outline-none focus:ring-thatBlue-500 
		md:text-lg
	">
	<div class="flex h-full w-full items-center justify-center">
		<slot />
	</div>
</div>
